export const TEACHER_LESSON_REPORT_JOURNAL_SCOPE_KEY = 'teacherLessonReportJournalScope';

const DEFAULT_SCOPE = {
  all_courses: true,
  courses: [],
};

const positiveId = (value) => {
  const id = Number(value);

  return Number.isInteger(id) && id > 0 ? id : null;
};

const defaultScope = () => ({ ...DEFAULT_SCOPE, courses: [] });

export const parseTeacherLessonReportJournalScope = (value) => {
  let scope = value;

  if (typeof value === 'string') {
    try {
      scope = JSON.parse(value);
    } catch (error) {
      return defaultScope();
    }
  }

  if (!scope || typeof scope !== 'object' || typeof scope.all_courses !== 'boolean') {
    return defaultScope();
  }
  if (scope.all_courses) {
    return defaultScope();
  }
  if (!Array.isArray(scope.courses) || !scope.courses.length) {
    return defaultScope();
  }

  const directionIds = new Set();
  const courses = [];
  for (const course of scope.courses) {
    const directionId = positiveId(course?.direction_id);
    if (!directionId || directionIds.has(directionId) || typeof course?.all_groups !== 'boolean') {
      return defaultScope();
    }

    directionIds.add(directionId);
    if (course.all_groups) {
      courses.push({ direction_id: directionId, all_groups: true });
      continue;
    }

    if (!Array.isArray(course.group_ids) || !course.group_ids.length) {
      return defaultScope();
    }

    const groupIds = course.group_ids.map(positiveId);
    if (groupIds.some((id) => !id) || new Set(groupIds).size !== groupIds.length) {
      return defaultScope();
    }

    courses.push({
      direction_id: directionId,
      all_groups: false,
      group_ids: groupIds,
    });
  }

  return { all_courses: false, courses };
};

const getReportGroup = (report) => (
  Array.isArray(report?.group) ? report.group[0] : report?.group
);

export const isTeacherLessonReportJournalRestrictionApplicable = (settings, report) => {
  if (String(settings?.isTeacherCannotReportOnTheLessonUntilHeHasGivenGradesToAllStudents) !== '1') {
    return false;
  }

  const scope = parseTeacherLessonReportJournalScope(
    settings?.[TEACHER_LESSON_REPORT_JOURNAL_SCOPE_KEY],
  );
  if (scope.all_courses) {
    return true;
  }

  const group = getReportGroup(report);
  const groupId = positiveId(group?.id ?? report?.group_id ?? report?.groups?.[0]);
  const directionId = positiveId(report?.direction_id ?? group?.direction_id);
  if (!groupId || !directionId) {
    return false;
  }

  const course = scope.courses.find((item) => item.direction_id === directionId);

  return Boolean(course && (course.all_groups || course.group_ids?.includes(groupId)));
};

